import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';

const OptOutEngagement = ({
  onClick,
  customer,
}) => (
  <div>
    <div
      display-if={customer.unsubscribedCampaign}
      className="u-fontsize-small u-type--semibold u-mb-"
    >
      {t('customers:form.engagement.opted_out_status')}
    </div>
    <button
      type="button"
      className="c-btn c-btn--medium"
      onClick={onClick}
      disabled={customer.unsubscribedCampaign}
    >
      {t('customers:form.engagement.opt_out_button')}
    </button>
  </div>
);

OptOutEngagement.propTypes = {
  onClick: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired,
};

export default OptOutEngagement;
